<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-form id="addissue_form" @submit.prevent="submit" v-model="isValid">
                <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"
                    @current-items="getFiltered">
                    <template v-slot:top>
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Add Issue</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" background-color="white" append-icon="search" label="Search"
                                single-line class="pr-3" hide-details> </v-text-field>
                            <v-dialog v-model="dialog" max-width="700px">
                                <template v-slot:activator="{ on }">
                                    <v-btn small class="mr-3" color="success" v-on="on">Add New Issue</v-btn>
                                </template>
                                <v-card>
                                    <v-form v-model="valid">
                                        <v-card-title class="toolbar">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="8" sm="8" md="5">
                                                        <v-autocomplete rounded outlined dense
                                                            v-model="editedItem.section" :items="section_list"
                                                            @change="getIssue()" return-object item-text="section_name"
                                                            item-value="section_id" label="Select Section"
                                                            name="section" :required="true" />
                                                    </v-col>

                                                    <v-col cols="8" sm="8" md="5">
                                                        <v-autocomplete :required="true" rounded outlined dense
                                                            v-model="editedItem.issue" :items="issue_list" return-object
                                                            item-text="issue_name" item-value="issue_id"
                                                            label="Select Issue" name="issue" />
                                                    </v-col>
                                                    <v-col cols="8" sm="8" md="2">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn class="mx-2" fab dark color="indigo" small
                                                                    title="add more issues"
                                                                    to="/role-dashboard/maintenance-issue-master"
                                                                    v-bind="attrs" v-on="on">
                                                                    <v-icon dark> mdi-plus </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Add New Issue</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12">
                                                        Description
                                                        <v-textarea v-model="editedItem.description"
                                                            placeholder="Add Description of Issue..." name="description"
                                                            :required="true"></v-textarea>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="6">
                                                        <v-autocomplete :required="true" rounded outlined dense
                                                            v-model="editedItem.room" :items="room_list" return-object
                                                            item-text="room_name" item-value="room_id"
                                                            label="Select Room" name="room" />
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="6">
                                                        <v-file-input placeholder="Upload file size limit <=2 MB!"
                                                            prepend-icon="mdi-attachment"
                                                            label="Upload Attachment if any!" show-size
                                                            v-model="editedItem.uploadfile" name="uploadfile"
                                                            :required="true"></v-file-input>
                                                    </v-col>
                                                    <v-col v-if="
                                                        editedItem.file != null && editedItem.file != ''
                                                    ">
                                                        <span>
                                                            <a class="p-2" :href="awspath + editedItem.file"
                                                                target="blank">
                                                                old attachment!
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                                                color="primary">mdi-file</v-icon></v-btn>
                                                                    </template>
                                                                    <span> View File</span>
                                                                </v-tooltip>
                                                            </a>
                                                        </span>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                            <v-btn class="mb-2 button" color="primary"
                                                @click="submit">Save</v-btn><v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                            <v-btn color="white" outlined small rounded v-if="table_list != ''">
                                <download-excel :data="table_list" :fields="table_fields" worksheet="add_issue"
                                    name="add_issue.xls"> <v-icon small dark>mdi-file-excel</v-icon> Export
                                </download-excel>
                            </v-btn>
                        </v-toolbar>
                        <v-row justify="center" align="center" class="pa-3">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete flat hide-details small class="pa-1" rounded dense
                                                        outlined color="#0F2027" :label="header.text" multiple clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>                            
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar style="" size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <div>
                            <v-avatar size="35">
                                <v-icon class="mr-4 v-icon-size" color="red"
                                    @click="deleteIssue(item)">mdi-trash-can</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:item.file="{ item }">
                        <span v-if="item.file != ''">
                            <a class="p-2" :href="awspath + item.file" target="blank">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                color="primary">mdi-eye</v-icon></v-btn>
                                    </template>
                                    <span> View File</span>
                                </v-tooltip>
                            </a>
                        </span>
                        <span v-else> -- </span>
                    </template>
                </v-data-table>
            </v-form>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        isValid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        filterArr: [],
        filters: {
            section: [],
            room: [],
            status: [],
            actionby: [],
            actiondate: [],
        },
        table_fields: {
            "Sr no.": "srno",
            Issue: "issue",
            "Action By": "actionby",
            "Post Date": "postdate",
            Section: "section",
            Room: "room",
            Description: "description",
            "Action Date": "actiondate",
            Remark: "remark"
        },
        headers: [
            { text: "Sr. No.", sortable: false, value: "srno" },
            { text: "Issue", align: "center", sortable: false, value: "issue" },
            {
                text: "Post Date",
                align: "center",
                sortable: false,
                value: "postdate",
            },
            {
                text: "Section",
                align: "center",
                sortable: false,
                value: "section",
            },
            { text: "Room", align: "center", sortable: false, value: "room" },
            { text: "File", align: "center", sortable: false, value: "file" },
            {
                text: "Description",
                align: "center",
                sortable: false,
                value: "description",
            },
            { text: "Status", align: "center", sortable: false, value: "status" },
            {
                text: "Action By",
                align: "center",
                sortable: false,
                value: "actionby",
            },
            {
                text: "Action Date",
                align: "center",
                sortable: false,
                value: "actiondate",
            },
            { text: "Remark", align: "center", sortable: false, value: "remark" },
            { text: "Action", align: "center", sortable: false, value: "action" },
            { text: "Delete", align: "center", sortable: false, value: "delete" },
        ],
        table_list: [],
        section_list: [],
        issue_list: [],
        room_list: [],
        editedIndex: -1,
        savedata: {
            name: "",
            section: "",
            isactive: "",
        },
        editedItem: {
            id: "",
            uploadfile: null,
            section: "",
            issue: "",
            description: "",
            room: "",
        },
        defaultItem: {
            id: "",
            uploadfile: null,
            section: "",
            issue: "",
            description: "",
            room: "",
        },
        awspath: null,
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Issue" : "Edit Issue";
        },
        bookList1() {
            return this.table_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.onLoad();
    },
    methods: {
        deleteIssue(item) {
            if (!confirm("Are You Sure You Want To Delete Issue...?")) return;
            const formdata = {
                id: item.id
            }
            this.overlay = true;
            axios
                .post("/MaintenanceSystem/deleteIssue", formdata)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        // this.table_list = res.data.table_list;
                        this.showSnackbar("green", "Deleted Successfully"); // show snackbar
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.onLoad();
                });
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.table_list.map((d) => d[val]);
        },
        getIssue() {
            this.issue_list = this.editedItem.section.issue_list;
            if (this.issue_list.length == 0) {
                alert("No Issues found!!!");
                this.issue_list = null;
            }
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        editItem(item) {
            this.editedIndex = this.table_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/MaintenanceSystem/getAddIssue")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.table_list = res.data.table_list;
                        this.section_list = res.data.section_list;
                        // this.issue_list = res.data.issue_list;
                        this.room_list = res.data.room_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        submit: function (e) {
            if (this.editedIndex > -1) {
                this.overlay = true;
                let formData = new FormData();
                if (typeof this.editedItem.issue == "object") {
                    formData.append("issue", this.editedItem.issue.issue_id);
                } else {
                    formData.append("issue", "");
                }
                if (typeof this.editedItem.section == "object") {
                    formData.append("section", this.editedItem.section.section_id);
                } else {
                    formData.append("section", "");
                }
                if (typeof this.editedItem.room == "object") {
                    formData.append("room", this.editedItem.room.room_id);
                } else {
                    formData.append("room", "");
                }
                formData.append("description", this.editedItem.description);
                formData.append("file", this.editedItem.uploadfile);
                formData.append("issue_id", this.editedItem.id);
                axios
                    .post("/MaintenanceSystem/editIssuefromStaff", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.status == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Issue Updated Successfully...");
                            this.onLoad();
                        } else if (res.data.status == "NA") {
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Issue Not Found!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    });
                this.close();
            } else {
                if (this.editedItem.issue == "" || this.editedItem.issue == null) {
                    this.showSnackbar("#b71c1c", "Please Select Issue!");
                    return;
                }
                if (this.editedItem.section == "" || this.editedItem.section == null) {
                    this.showSnackbar("#b71c1c", "Please Select Section!");
                    return;
                }
                if (this.editedItem.room == "" || this.editedItem.room == null) {
                    this.showSnackbar("#b71c1c", "Please Select Room!");
                    return;
                }
                let formData = new FormData();
                formData.append("issue_id", this.editedItem.id);
                formData.append("section", this.editedItem.section.section_id);
                formData.append("description", this.editedItem.description);
                formData.append("issue", this.editedItem.issue.issue_id);
                formData.append("file", this.editedItem.uploadfile);
                formData.append("room", this.editedItem.room.room_id);
                this.overlay = true;
                axios
                    .post("/MaintenanceSystem/addIssue", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        // console.log({ res });
                        this.overlay = false;
                        if (res.data.status == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Issue Added Successfully...");
                            this.onLoad();
                        } else if (res.data.status == "NA") {
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "This Issue Already Present!!!");
                        } else if (res.data.status == "FILEERROR") {
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Attachment is not uploaded!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    });
                this.close();
            }
        }, //save()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>
